<template>
  <div class="clinic-result-header" >
    <b-row>
      <b-col cols="12" lg="6"  class="d-flex align-items-center"> 
        <b-skeleton type="text" width="100%" height="21px" v-if="loading" class="skeleton-img"></b-skeleton>
        <div v-else class="service-location-text ">
          Próximo a <b>{{ locationInfo }}</b> 
        </div>
      </b-col>
      <b-col cols="12" lg="6" class="d-flex align-items-center justify-content-end">
        <b-skeleton width="139px" height="37px" v-if="loading"></b-skeleton>
        <div v-else class="sort-by-dropdown">
          <v-select
            :searchable="false"
            :clearable="false"
            placeholder="Ordenar por"
            class="style-chooser"
            v-model="cx_selectedSort"
            @option:selected="$emit('changeSearchSort', cx_selectedSort)"
            :options="sortOptions"
            :reduce="(option) => option.value"
            label="label">
          </v-select>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ClinicResultHeader from "@/components/ClinicsResult/ClinicResultHeader/ClinicResultHeader";
export default ClinicResultHeader;
</script>

<style lang="scss">
@import "ClinicResultHeader.scss";
</style>
